import { useFlags } from "launchdarkly-react-client-sdk";

import { checkPermissions } from "./checkPermissions";

export const BYPASS_RLS_PERMISSION = "population.bypass_rls_population";

// Mirrors cc-api's user_is_restricted: enforcement needs the tenant flag on and the user lacking the bypass permission.
export function useRlsRestricted(): boolean {
  const { populationBuilderRls } = useFlags();
  return !!populationBuilderRls && !checkPermissions(BYPASS_RLS_PERMISSION);
}
